<div class="modal-header">
  <h4 class="modal-title header-13">Add to Test Suite</h4>
  <button
    type="button"
    class="accello-icon-btn"
    (mousedown)="isActive = true"
    (mouseup)="isActive = false"
    (mouseleave)="isActive = false"
    (click)="activeModal.dismiss('Cross click')"
    aria-label="Close"
  >
    <img
      [src]="
        isActive
          ? 'assets/images/virtusa-icons/close-dark.svg'
          : 'assets/images/virtusa-icons/close.svg'
      "
      alt="Close"
    />
  </button>
</div>

<div class="modal-body">
  <div class="info-banner">
    <span class="info-banner__bullet" aria-hidden="true"></span>
    <span class="info-banner__text">
      Selected test cases will be added to the test suite below.
    </span>
  </div>

  <div class="suite-field">
    <label class="suite-label" for="testSuiteNameInput">
      Test Suite name <span class="suite-required">*</span>
    </label>
    <input
      id="testSuiteNameInput"
      type="text"
      class="form-control suite-input"
      placeholder="Add test suite name"
      [(ngModel)]="testSuiteName"
      (keydown.enter)="submit()"
      autocomplete="off"
    />
  </div>
</div>

<div class="modal-footer">
  <div class="d-flex justify-content-end">
    <button
      type="button"
      class="btn btn-accello-secondary mx-2"
      (click)="activeModal.dismiss('Cross click')"
    >
      Cancel
    </button>
    <button
      type="button"
      class="btn btn-accello-primary-light"
      [disabled]="!canSubmit"
      (click)="submit()"
    >
      {{ configs?.saveBtnText ? configs.saveBtnText : 'Add' }}
    </button>
  </div>
</div>
